import gql from "graphql-tag"

export const createAnonimalOrder = gql`
  mutation CreateAnonimalOrder($input: StoreAnonimalOrderInput!) {
    storeAnonimalOrder(input: $input) {
      success
    }
  }
`
